import React, { useEffect, useState, useCallback } from "react";
import api from "../api/api";

const SuperAdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [hospitals, setHospitals] = useState([]);
// const [commissionData, setCommissionData] = useState({});
const [configMap, setConfigMap] = useState({});

  // ✅ ONLY CHANGE: hospitalpharmacist added
  const roles = [
    "admin",
    "pharmacist",
    "hospitalpharmacist", // ✅ NEW ROLE
    "doctor",
    "delivery",
    "patient",
  ];

  // SUPERADMIN ACCESS CHECK
  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (!role || role !== "superadmin") {
      window.location.href = "/login";
    }
  }, []);

  // ✅ FETCH ALL USERS (NO FILTER)
  const fetchUsers = useCallback(async () => {
    try {
      const res = await api.get("/users/");
      setUsers(res.data);
    } catch (error) {
      console.log("Fetch error:", error);
    }
  }, []);
const fetchHospitals = async () => {
  const res = await api.get("/hospitals/");
  setHospitals(res.data);
};


const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this user?")) return;

  try {
    await api.patch(`/users/soft-delete/${id}/`);
    alert("User deleted successfully");
    fetchUsers();
  } catch (error) {
    alert("Delete failed");
  }
};


useEffect(() => {
  fetchHospitals();
}, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

useEffect(() => {
  users.forEach((u) => {
    if (u.role === "hospitalpharmacist") {
      fetchConfig(u.id);  // 🔥 LOAD SAVED DATA
    }
  });
}, [users]);



  // UPDATE ROLE
const handleRoleChange = async (id, newRole, hospitalId = null) => {
  try {
    await api.put(`/users/update/${id}/`, {
      role: newRole,
      hospital: hospitalId,
    });
    fetchUsers();
    alert("Role updated successfully");
  } catch (error) {
    alert(error.response?.data?.error || "Error updating role");
  }
};


  // BLOCK USER
  const blockUser = async (id) => {
    await api.post(`/users/block/${id}/`);
    fetchUsers();
  };

  // UNBLOCK USER
  const unblockUser = async (id) => {
    await api.post(`/users/unblock/${id}/`);
    fetchUsers();
  };

  // LOGOUT
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userRole");
    window.location.href = "/login";
  };

  // SEARCH FILTER (same as old)
  const filtered = users.filter(
    (u) =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.phone?.includes(search)
  );


const saveCommissionConfig = async (userId) => {
  const data = configMap[userId];

  if (!data?.hospital || !data?.commission || !data?.discount) {
    alert("Select hospital, commission and discount");
    return;
  }

  if (Number(data.discount) > Number(data.commission)) {
    alert("Discount cannot be greater than commission");
    return;
  }

  try {
    await api.post("/hospital-pharmacist-config/", {
      pharmacist: userId,
      hospital: data.hospital,
      hospital_commission_percent: data.commission,
      user_discount_percent: data.discount,
    });
 setConfigMap((prev) => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        commission: data.commission,
        discount: data.discount,
      },
    }));
await fetchConfig(userId);
    alert("Commission config saved");
  } catch (err) {
    alert(err.response?.data?.error || "Error saving commission");
  }
};
const fetchConfig = async (userId) => {
  try {
    const res = await api.get(`/hospital-pharmacist-config/${userId}/`);
 console.log("CONFIG:", userId, res.data);
    if (res.data.length > 0) {
      const c = res.data[0];

      setConfigMap((prev) => ({
        ...prev,
        [userId]: {
          hospital: String(c.hospital),
          commission: String(c.commission),
discount: String(c.discount),
        },
      }));
    }
  } catch {}
};
useEffect(() => {
  const newMap = {};

  users.forEach((u) => {
    if (u.role === "hospitalpharmacist") {
      newMap[u.id] = {
        hospital: u.hospital ? String(u.hospital) : "",
        commission: "",
        discount: "",
      };
    }
  });

  setConfigMap((prev) => ({
  ...prev,
  ...newMap,
}));
}, [users]);


  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Super Admin – User Management</h1>
        <button
          onClick={handleLogout}
          className="bg-red-600 text-white px-4 py-2 rounded"
        >
          Logout
        </button>
      </div>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search name or phone"
        className="border p-2 mb-4 w-full rounded"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* USERS TABLE */}
      <table className="w-full border">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-3">Name</th>
            <th className="p-3">Phone</th>
            <th className="p-3">Role</th>
            <th className="p-3">Status</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>

        <tbody>
          {Array.isArray(filtered) && filtered.map((u) => (
            <tr key={u.id} className="border-b">
              <td className="p-3">{u.name || "N/A"}</td>
              <td className="p-3">{u.phone}</td>

              <td className="p-3">
<select
  value={u.role}
 onChange={(e) => {
  const newRole = e.target.value;

  // 🔥 hospitalpharmacist ke case me API call mat karo
  if (newRole === "hospitalpharmacist") {
    setUsers((prev) =>
      prev.map((user) =>
        user.id === u.id ? { ...user, role: newRole } : user
      )
    );
    return;
  }

  // ✅ normal roles ke liye call
  handleRoleChange(u.id, newRole, null);
}}
  className="border p-1 rounded"
>
  {roles.map((r) => (
    <option key={r} value={r}>
      {r.toUpperCase()}
    </option>
  ))}
</select>

{u.role === "hospitalpharmacist" && (
  <div className="mt-3 bg-gray-50 p-3 rounded border">
    <div className="grid grid-cols-4 gap-3 items-center">

      {/* Hospital */}
      <select
        className="border p-2 rounded"
       


// value={configMap[u.id]?.hospital || ""}

value={configMap[u.id]?.hospital ?? u.hospital ?? ""}



onChange={(e) => {
  const hospitalId = e.target.value;

  // 1️⃣ backend update (existing logic)
  handleRoleChange(u.id, "hospitalpharmacist", hospitalId);

  // 2️⃣ local state update (IMPORTANT)
  setConfigMap((prev) => ({
    ...prev,
    [u.id]: {
      ...prev[u.id],
      hospital: hospitalId,
    },
  }));
}}

      >
        <option value="">Select Hospital</option>
        {hospitals.map((h) => (
          <option key={h.id} value={h.id}>
            {h.name}
          </option>
        ))}
      </select>

      {/* Commission */}
      <input
        type="number"
        placeholder="Commission %"
        className="border p-2 rounded"
        value={configMap[u.id]?.commission || ""}
        onChange={(e) =>
          setConfigMap((prev) => ({
            ...prev,
            [u.id]: {
              ...prev[u.id],
              commission: e.target.value,
            },
          }))
        }
      />

      {/* Discount */}
      <input
        type="number"
        placeholder="Discount %"
        className="border p-2 rounded"
        value={configMap[u.id]?.discount || ""}
        onChange={(e) =>
          setConfigMap((prev) => ({
            ...prev,
            [u.id]: {
              ...prev[u.id],
              discount: e.target.value,
            },
          }))
        }
      />

      {/* Save */}
      <button
        onClick={() => saveCommissionConfig(u.id)}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Save
      </button>

    </div>
  </div>
)}



              </td>

              <td className="p-3">
                {u.is_blocked ? (
                  <span className="text-red-600 font-bold">
                    BLOCKED
                  </span>
                ) : (
                  <span className="text-green-600 font-bold">
                    ACTIVE
                  </span>
                )}
              </td>

              <td className="p-3 flex gap-2">
  {!u.is_blocked ? (
    <button
      onClick={() => blockUser(u.id)}
      className="bg-red-500 text-white px-3 py-1 rounded"
    >
      Block
    </button>
  ) : (
    <button
      onClick={() => unblockUser(u.id)}
      className="bg-green-500 text-white px-3 py-1 rounded"
    >
      Unblock
    </button>
  )}

  <button
    onClick={() => handleDelete(u.id)}
    className="bg-black text-white px-3 py-1 rounded"
  >
    🗑️ Delete
  </button>
</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SuperAdminUsers;
